import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'out-external-links',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './external-links.component.html',
  styleUrl: './external-links.component.scss',
})
export class ExternalLinksComponent {
  @Input() link!: SafeUrl;
  @Input() text = '';
  @Input() class = '';
}
